module.exports = __webpack_public_path__ + "img/Citizenship.10cd5231.png";